<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackUp"
      :placeholder="placeholder"
      :style="width ? `width: ${width}` : ''"
      :multiple="multiple"
      filterable
      :disabled="disabled"
      :remote="remote"
      :remote-method="search"
      :clearable="clearable"
      :size="size"
      @change="handleChange"
    >
      <v-avatar-option :value="listBackUp" uni-key="AdministratorAvatarOption"/>
    </el-select>
  </div>
</template>

<script>
import { index } from '@/api/administrator';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    storeId: [Number, String],
    width: String,
    remote: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    placeholder: {
      type: String,
      default: '请选择管理员',
    },
    label: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  data: () => ({
    valueBackUp: '',
    listBackUp: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackUp)) this.valueBackUp = value || [];
      } else {
        if (value !== this.valueBackUp) this.valueBackUp = +value || '';
      }
    },
    valueBackUp(valueBackUp) {
      if (this.multiple) {
        if (JSON.stringify(valueBackUp) !== JSON.stringify(this.value)) this.$emit('input', valueBackUp);
      } else {
        if (valueBackUp !== (+this.value || '')) this.$emit('input', valueBackUp);
      }
    },
    storeId(storeId) {
      if (storeId) this.getList({ store_id: this.storeId, is_all: 1 });
    },
  },
  methods: {
    async search(keyword) {
      if (!keyword) return;
      const { isError, data } = await index({
        keyword: keyword || '',
        is_not_filter_del: 1,
        is_only_list: 1,
      });
      if (isError) return;

      this.listBackUp = data || [];
    },
    async getList({ store_id, keyword, is_all }) {
      const { isError, data } = await index({
        store_id: store_id || 0,
        keyword: keyword || '',
        is_all: store_id ? (is_all ? 1 : 0) : 0,
      });
      if (isError) return;

      this.listBackUp = store_id
        ? (data || [])
        : (data.list || []);
    },
    handleChange(valueBackUp) {
      this.$emit('change', valueBackUp);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackUp = this.value || [];
    } else {
      this.valueBackUp = +this.value || '';
    }

    if (this.list.length) return this.listBackUp = this.list;
    this.getList({ store_id: this.storeId, is_all: 1 });
  },
};
</script>
